<script type="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { Alert, Heading } from "@getprovi/craft-svelte";

  export let retailerUserAuthStatus: string;
  export let authService: any;
</script>

<style>
</style>

<div class="fizz-flex-item">
  {#if retailerUserAuthStatus == "pending"}
    <div data-testid="retailer-user-auth-pending">
      <div class="fizz-flex-row fizz-stack-4 fizz-space-between">
        <div style="max-width: 200px;">
          <p class="craft">
            <Heading as="h3" class="" size="h3"><slot name="pending-title" /></Heading>
          </p>
        </div>

        <div>
          <Icon type="Containers" width="117" height="90" />
        </div>
      </div>
      <p class="fizz-stack-12" style="max-width: 360px">
        <slot name="pending-description" />
      </p>

      <div class="craft">
        <slot name="pending-buttons" />
      </div>
    </div>
  {:else if retailerUserAuthStatus == "invalid"}
    <div class="craft">
      <Alert
        variant="warning"
        title={authService?.invalidTitle}
        testId="retailer-user-auth-invalid"
      >
        <slot name="invalid-description" />

        <svelte:fragment slot="actions">
          <slot name="invalid-buttons" />
        </svelte:fragment>
      </Alert>
    </div>
  {/if}
</div>
